import { IPlaceOrderIdResponse } from '../interfaces';

export const acceptOrder = (requestId: number): IPlaceOrderIdResponse => ({
    isAccepted: true,
    reason: '',
    requestId,
});

export const rejectOrder = (requestId: number): IPlaceOrderIdResponse => ({
    isAccepted: false,
    reason: 'Requested quantity is less than the minimum required trade size',
    requestId,
});
